import Phaser from "phaser";
import blueBtn from "@assets/imgs/btns/blue-btn.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

export class BlueBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;
  private label: Phaser.GameObjects.Text;

  static preload(scene: Phaser.Scene) {
    scene.load.image("blue-btn", blueBtn);
  }

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    text: string,
    onClick: () => void,
  ) {
    super(scene, x, y, {
      onClick,
      sfx: () => AudioManager.playSfx("sfx-button"),
      onPress: () => this.setPressedStyle(),
      onRelease: () => this.resetButton(),
    });

    this.bg = scene.add.image(0, 0, "blue-btn").setOrigin(0.5);

    this.label = scene.add
      .text(0, 0, text, {
        fontFamily: "Black Han Sans",
        fontSize: "64px",
        color: "#1C120E",
      })
      .setOrigin(0.5);

    this.add([this.bg, this.label]);

    this.enableButton(this.bg.width, this.bg.height);

    scene.add.existing(this);
  }

  private setPressedStyle() {
    this.setScale(0.9);
  }

  private resetButton() {
    this.setScale(1);
  }
}
